/* Almara: i regali Kaching (Garanzia, Guida) restano una sola volta nel carrello.
   Kaching aggiunge i regali a ogni riga-bundle: qui si tolgono i doppioni e, se il
   bundle "proprietario" dei regali viene rimosso mentre nel carrello resta un altro
   prodotto con bundle (di qualunque offerta), i regali si riattaccano a quello,
   preferendo un bundle della stessa offerta. Se Kaching non li considera regalo per
   quel bundle (prezzo sopra zero), si tolgono: il cliente non paga mai un regalo. */
(function () {
  if (window.__almGiftOnce) return;
  window.__almGiftOnce = true;

  var busy = false;
  var timer = null;
  var memo = {}; // variant_id -> { deal, gift }

  function parse(line) {
    try {
      return JSON.parse(line.properties && line.properties.__kaching_bundles);
    } catch (e) {
      return null;
    }
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function redraw() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.getSectionsToRender) return Promise.resolve();
    var sections = drawer.getSectionsToRender();
    var ids = sections.map(function (s) { return s.id; }).join(',');
    return fetch('/?sections=' + ids, { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        sections.forEach(function (s) {
          var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
          if (el && data[s.id]) el.innerHTML = drawer.getSectionInnerHTML(data[s.id], s.selector);
        });
      });
  }

  async function run() {
    if (busy) return;
    busy = true;
    try {
      var cart = await (await fetch('/cart.js', { cache: 'no-store' })).json();
      var mains = {};
      var seen = {};
      var extras = [];
      cart.items.forEach(function (line) {
        var p = parse(line);
        if (p && p.main) mains[p.id] = line;
      });
      cart.items.forEach(function (line) {
        var p = parse(line);
        if (!p || p.main || !p.gift) return;
        memo[line.variant_id] = { deal: p.deal, gift: p.gift };
        // doppione, oppure regalo rimasto legato a un bundle che non c'è più
        if (seen[line.variant_id] || !mains[p.id]) {
          extras.push(line.key);
        } else {
          seen[line.variant_id] = true;
        }
      });

      var toAdd = [];
      var ids = Object.keys(mains);
      Object.keys(memo).forEach(function (variant) {
        if (seen[variant]) return;
        var m = memo[variant];
        delete memo[variant];
        if (!ids.length) return;
        var id = ids.find(function (k) { return parse(mains[k]).deal === m.deal; }) || ids[0];
        var owner = parse(mains[id]);
        toAdd.push({
          id: Number(variant),
          quantity: 1,
          properties: { __kaching_bundles: JSON.stringify({ id: id, deal: owner.deal, v: owner.v, gift: m.gift }) }
        });
      });

      for (var i = 0; i < extras.length; i++) {
        await post('/cart/change.js', { id: extras[i], quantity: 0 });
      }
      if (toAdd.length) {
        await post('/cart/add.js', { items: toAdd });
        var added = {};
        toAdd.forEach(function (a) { added[a.id] = true; });
        var after = await (await fetch('/cart.js', { cache: 'no-store' })).json();
        var paid = after.items.filter(function (l) {
          var p = parse(l);
          return p && p.gift && added[l.variant_id] && l.final_line_price > 0;
        });
        for (var j = 0; j < paid.length; j++) {
          delete memo[paid[j].variant_id];
          await post('/cart/change.js', { id: paid[j].key, quantity: 0 });
        }
      }
      if (extras.length || toAdd.length) await redraw();
    } catch (e) {
      /* il carrello resta com'è: nessun blocco per il cliente */
    } finally {
      busy = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 1200);
  }

  var CART_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : input && input.url;
    var p = origFetch.apply(this, arguments);
    if (url && CART_URL.test(url)) p.then(schedule, function () {});
    return p;
  };

  window.addEventListener('load', schedule);
})();
